import { FC, useCallback } from "react"
import { useParams } from "react-router-dom"
import { Locker } from "shared/locker"
import { LockerThingTypeMrn } from "shared/lockerData"
import { useAppSelector } from "src/app/hooks"
import { selectMeIsReady, selectTenantId } from "src/features/me/meSlice"
import { useGetCurrentSmsDeliveriesQuery } from "src/features/things/thingsApi"
import {
  selectLockerMetrics,
  selectThingsByThingTypeMrnFilter,
} from "src/features/things/thingsSlice"
import OsLayout from "./OsLayout"
import OsLockerDashboard from "./OsLockerDashboard"
import OsLockerDashboardV2 from "./OsLockerDashboardV2"

export const OsLockerPage: FC = () => {
  const { lockerId } = useParams()

  const tenantId = useAppSelector(selectTenantId)

  const isReady = useAppSelector(selectMeIsReady)

  const lockersMetrics = useAppSelector(selectLockerMetrics)

  const filterFn = useCallback(
    (thing: Locker) => thing.id === lockerId,
    [lockerId],
  )

  const locker = useAppSelector((s) =>
    selectThingsByThingTypeMrnFilter(s, LockerThingTypeMrn, filterFn),
  )[0] as unknown as Locker | undefined

  const smsDeliveriesQuery = useGetCurrentSmsDeliveriesQuery(
    {
      params: {
        tenantId: tenantId!,
      },
    },
    {
      skip: !tenantId || !isReady,
    },
  )
  return (
    <OsLayout selectedMenuItemLabelKey="lockers">
      {lockerId && locker?.sstApiVersion === "v2" ? (
        <OsLockerDashboardV2 locker={locker} />
      ) : (
        lockerId && (
          <OsLockerDashboard
            lockerId={lockerId}
            metrics={lockersMetrics[lockerId]}
            smsDeliveries={smsDeliveriesQuery.data?.things || []}
          />
        )
      )}
    </OsLayout>
  )
}

export default OsLockerPage
